"use client";
import Link from "next/link";
import React, { useState } from "react";
import Icon from "../primitives/icon";

interface Sportsbook {
  id: Number,
  attributes: {
    title: String,
    slug: String,
    description: String,
    color: String,
    logo: Object,
    light_logo: Object,
    legal_states: Object
  }
}

interface SportsbooksDropdownProps {
  label: String;
  sportsbooks: Sportsbook[];
}

export default function SportsbooksDropdown({ label, sportsbooks }: SportsbooksDropdownProps) {
  let [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <a
        className="block text-secondary-100 uppercase cursor-pointer"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >{label} <Icon className="ml-1 align-middle" name="caret-down" size="xs"></Icon></a>
      {isOpen &&
        <div className="pl-6">
          {sportsbooks.map((sportsbook: Sportsbook) => (
            <Link className="block text-secondary-100 uppercase" href={`/sportsbooks/${sportsbook.attributes.slug}`}>{sportsbook.attributes.title}</Link>
          ))}
        </div>
      }
    </>
  );
}
